import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.error(err);
      } finally {
        isMounted && setIsLoading(false);
      }
    };

    // Always ask the server to restore a browser session. A non-persistent
    // session cookie naturally disappears when the browser session ends.
    !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);

    return () => {
      isMounted = false;
    };
  }, []);

  // useEffect(() => {
  //   console.log(`isLoading: ${isLoading}`)
  //   console.log(`aT: ${JSON.stringify(auth?.accessToken)}`)
  // }, [isLoading])

  return (
    <>{isLoading ? <p>Loading...</p> : <Outlet />}</>
  );
};

export default PersistLogin;
